document.addEventListener('DOMContentLoaded', function() {
  var testimonialSlider = document.querySelector(".testimonial-slider");
  if (testimonialSlider && testimonialSlider.children.length > 0) {
    // Calculate startIndex to center the active slide
    var slideCount = testimonialSlider.children.length;
    var startIndex = Math.floor(slideCount / 2);
    
    var slider = tns({
      container: testimonialSlider,
      items: 1,
      slideBy: 1,
      nav: false,
      controls: true,
      controlsText: [
        '<span class="visually-hidden">Previous testimonial</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.79 45.18"><polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" points="43.29 22.54 1.74 22.54 21.74 1.5 1.5 22.54 21.74 43.68"/></svg>',
        '<span class="visually-hidden">Next testimonial</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.79 45.18"><polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" points="1.5 22.63 43.05 22.63 23.05 43.68 43.29 22.63 23.05 1.5"/></svg>'
      ],
      loop: true,
      mouseDrag: true,
      autoplay: false,
      center: true,
      startIndex: startIndex,
      gutter: 0
    });
  }
});

